import React, { useState, useEffect } from "react";
import {NoResultProperties} from '../../queries/common_use_query';
import PropertyCard from "../PropertyCard/PropertyCard";
import { isMobile } from 'react-device-detect';

const PropertyNoResult = (props) => {
    
    const[department, setDepartment] = useState('residential');

    useEffect(()=>{
        props.department && setDepartment(props.department);
    },[props.department]);

    const {loading:loading, error:error, data:data} = NoResultProperties(props.status, department);

    return (
        <React.Fragment>
            {
                data && data.properties.length > 0 &&
                <>
                    <p class="results-page-wrapper mb-5">We have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</p>
                    {
                        data.properties.map((hit, index) => {

                            // property details url structure
                            let uriStr = "";
                    
                            if (hit.search_type === "sales" && hit.department === 'residential') {
                                uriStr = `property-for-sale/`
                            } else if (hit.search_type === "lettings" && hit.department === 'residential') {
                                uriStr = `property-to-rent/`
                            }
                            // property details url structure

                            return (
                                <PropertyCard 
                                    price={"£"+hit.price.toLocaleString()}
                                    propertyid={hit.id}
                                    location={hit.display_address}
                                    description={hit.description}
                                    bedroomsCount={hit.bedroom}
                                    status={hit.status}
                                    bathroomsCount={hit.bathroom}
                                    floorarea ={hit.floor_area}
                                    floorarea_type={hit.floorarea_type}
                                    receptionsCount={hit.reception}
                                    propertyVideo={hit.virtual_tour}
                                    propertyImages={hit.images}                                    
                                    propertyDetailsLink={`/${uriStr}${hit.slug}-${hit.id}/`}
                                    propertySearchType={hit.search_type}
                                    noResulttag={"noResultsProperty"}
                                    // gridview={isMobile}
                                    gridview={props?.gridview}
                                />
                            )
                        })
                    }
                </>
            }
        </React.Fragment>
    )
}

export default PropertyNoResult;
